/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicAlertConfiguration extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicAlertConfiguration");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicAlertConfiguration.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicAlertConfiguration>): BackgroundJobPayloadForPeriodicAlertConfiguration {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicAlertConfiguration(), model);
        BackgroundJobPayloadForPeriodicAlertConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicAlertConfiguration>): BackgroundJobPayloadForPeriodicAlertConfiguration {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicAlertConfiguration.newInstance(<BackgroundJobPayloadForPeriodicAlertConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicAlertConfiguration) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicAlertConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicAlertConfiguration): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicAlertConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
